import React, { Component, createRef } from "react";

import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { withTranslation } from "react-i18next";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

class SalesUserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();

    const modifiedV = { ...this.state.validation };

    this.setState({ validation: modifiedV });
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    document.title = "sales office";
    const { validation } = this.state;
    return (
      
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("My Profile")} />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                      <div className="d-lg-flex d-block text-center text-lg-start justify-content-between">
                      <div>
                        <h4 className="text-black fw-bold mb-4">{this.props.t('My Profile')}</h4>
                        </div>
                        <div>
                          <h4 className="fw-bold">Role: <span className="text-black">Grader</span></h4>
                        </div>
                      </div>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        username:
                          (this.state && this.state.username) || "",
                        usercode: (this.state && this.state.usercode) || "",
                        address1: (this.state && this.state.address1) || "",
                        address2: (this.state && this.state.address2) || "",
                        city: (this.state && this.state.city) || "",
                        state: (this.state && this.state.state) || "",
                        mobile1: (this.state && this.state.mobile1) || "",
                        mobile2: (this.state && this.state.mobile2) || "",
                        email: (this.state && this.state.email) || "",
                      }}
                      validationSchema={Yup.object().shape({
                        attachment: Yup.mixed()
                          .nullable()
                          .notRequired()
                          .test(
                            "FILE_SIZE",
                            "Uploaded file is too big.",
                            value =>
                              !value || (value && value.size <= FILE_SIZE)
                          )
                          .test(
                            "FILE_FORMAT",
                            "Uploaded file has unsupported format.",
                            value =>
                              !value ||
                              (value && SUPPORTED_FORMATS.includes(value.type))
                          ),
                        username: Yup.string().required(
                          "Please Enter Your Name"
                        ),
                        usercode: Yup.string().required(
                          "Please Enter Your User Code"
                        ),
                        address1: Yup.string().required(
                          "Please Enter Your Address"
                        ),
                        address2: Yup.string().required(
                          "Please Enter Your Address"
                        ),
                        city: Yup.string().required("Please Enter Your city"),
                        state: Yup.string().required("Please Enter Your state"),
                        mobile1: Yup.string().required(
                          "Please Enter Your Mobile Number"
                        ),
                        mobile2: Yup.string().required(
                          "Please Enter Your Mobile Number"
                        ),
                        email: Yup.string().required("Please Enter Your email"),
                      })}
                      onSubmit={values => {}}
                    >
                      {({ errors, status, touched, values }) => (
                        <Form className="needs-validation">
                          <Row>
                            <div className="mb-3 row">
                              <label
                                htmlFor="example-number-input"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                Photo
                                </h5>
                              </label>
                              <div className="col-md-10">
                                <img src="images/dashboard-images/userprofile.svg" alt="user-profile" />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="username"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                {this.props.t("User Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.username && touched.username
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="username"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="username"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="usercode"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                User Code
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.usercode && touched.usercode
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="usercode"
                                  placeholder="ADM00001"
                                />
                                <ErrorMessage
                                  name="usercode"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="email"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Email ID')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.email && touched.email
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="email"
                                  placeholder="xyzdiamond123@gmail.com"
                                />
                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="mobile1"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Mobile no.1')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.mobile1 && touched.mobile1
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number" onWheel={(e) => e.target.blur()}
                                  name="mobile1"
                                  placeholder="+91 (132)(564)(9872)"
                                />
                                <ErrorMessage
                                  name="mobile1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="mobile2"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Mobile no.2')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.mobile2 && touched.mobile2
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number" onWheel={(e) => e.target.blur()}
                                  name="mobile2"
                                  placeholder="+91 (132)(564)(9872)"
                                />
                                <ErrorMessage
                                  name="mobile2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>                            
                            <div className="mb-3 row">
                              <Label
                                htmlFor="address1"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Address line 1')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.address1 && touched.address1
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="address1"
                                  placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                />
                                <ErrorMessage
                                  name="address1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="address2"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('Address line 2')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.address2 && touched.address2
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="address2"
                                  placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                />
                                <ErrorMessage
                                  name="address2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="city"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('City')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.city && touched.city
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="city"
                                  placeholder="City"
                                />
                                <ErrorMessage
                                  name="city"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="state"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">{this.props.t('State')}</h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.state && touched.state
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="state"
                                  as="select"
                                >
                                  <option value="" disabled>select</option>
                                  <option value="Gujarat">Gujarat</option>
                                  <option value="Maharashtra">
                                    Maharashtra
                                  </option>
                                  <option value="Tamil Nadu">Tamil Nadu</option>
                                  <option value="Uttar Pradesh">
                                    Uttar Pradesh
                                  </option>
                                  <option value="West Bengal">
                                    West Bengal
                                  </option>
                                  <option value="Karnataka">Karnataka</option>
                                  <option value="Rajasthan">Rajasthan</option>
                                  <option value="Andhra Pradesh">
                                    Andhra Pradesh
                                  </option>
                                  <option value="Madhya Pradesh">
                                    Madhya Pradesh
                                  </option>
                                </Field>
                                <ErrorMessage
                                  name="state"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="col-md-12 text-end">
                              <Button
                                color="primary"
                                className="fs-4 px-5"
                                type="submit"
                              >
                                Save
                              </Button>
                            </div>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(SalesUserProfile);